export const IS_FEDERATED = window.location.host !== 'partners.hiyllo.business';
